import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import {
  GetLoggedOnUser,
  IsQCLaborUser,
  IsTraderCompany,
  updateCountUnreadMessages,
  updateUnreadQCRequests,
  updateUnreadRepairRequests,
} from "helpers/misc_helpers"
import {
  useUnreadMessagesCount,
  useUnreadQCRequestsCount,
  useUnreadRepairRequestsCount,
} from "helpers/custom_hooks"

const SidebarContent = props => {
  const ref = useRef()
  const [countMessages, setCountMessages] = useUnreadMessagesCount()
  const [unreadQCRequestsCount, setUnreadQCRequestsCount] =
    useUnreadQCRequestsCount()
  const [unreadRepairRequestsCount, setUnreadRepairRequestsCount] =
    useUnreadRepairRequestsCount()
  const loggedOnUser = GetLoggedOnUser()

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName.startsWith(items[i].pathname)) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()

    updateCountUnreadMessages(setCountMessages)
    updateUnreadQCRequests(setUnreadQCRequestsCount)
    updateUnreadRepairRequests(setUnreadRepairRequestsCount)
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            {!IsQCLaborUser() && (
              <>
                {" "}
                <li>
                  <Link to="/dashboard">
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Dashboards")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/parts-upload">
                    <i className="bx bx-upload"></i>
                    <span>{props.t("Parts Upload")}</span>
                  </Link>
                </li>
                <br />
                <li>
                  <Link to="/watchlist">
                    <i className="bx bx-list-ol"></i>
                    <span>{props.t("Watchlist")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/saved-parts">
                    <i className="bx bx-pin"></i>
                    <span>{props.t("Saved Parts")}</span>
                  </Link>
                </li>
                <br />
                <li>
                  <Link to="/part-search">
                    <i className="bx bx-search-alt-2"></i>
                    <span>{props.t("Part Search")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/requests">
                    <i className="bx bx-chat"></i>
                    {countMessages > 0 && (
                      <span className="badge rounded-pill bg-primary float-end">
                        {countMessages}
                      </span>
                    )}
                    <span>{props.t("Requests")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/trader-requests">
                    <i className="bx bx-store-alt"></i>
                    <span>{props.t("Excess Price Check")}</span>
                  </Link>
                </li>
              </>
            )}
            <br />
            <br />
            <li>
              <Link to="/qc-requests">
                <i className="bx bx-chat"></i>
                {unreadQCRequestsCount > 0 && (
                  <span className="badge rounded-pill bg-primary float-end">
                    {unreadQCRequestsCount}
                  </span>
                )}
                <span>{props.t("QC Requests")}</span>
              </Link>
            </li>
            {!IsTraderCompany() && (
              <>
                <br />
                <br />

                <li>
                  <Link to="/repair-requests">
                    <i className="bx bx-wrench"></i>
                    {unreadRepairRequestsCount > 0 && (
                      <span className="badge rounded-pill bg-primary float-end">
                        {unreadRepairRequestsCount}
                      </span>
                    )}
                    <span>{props.t("Repair Requests")}</span>
                  </Link>
                </li>
                <br />
                <br />

                <li>
                  <Link to="/cps-requests">
                    <i className="mdi mdi-code-tags"></i>
                    <span>{props.t("CPS Programming")}</span>
                  </Link>
                </li>
                <br />
                <br />

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-group"></i>
                    <span>{props.t("Partner Cockpit")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/partner-cockpit">
                        {props.t("My Partner Cockpits")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partner-cockpit/part-list">
                        {props.t("Partner Cockpit Search")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partner-cockpit/my-material-stock">
                        {props.t("My Material Stock")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partner-cockpit/demand-list">
                        {props.t("My Demand List")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/partner-cockpit/loa-list">
                        {props.t("My LOA List")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <br />
                <br />
              </>
            )}
            {loggedOnUser?.userType == "Admin" && (
              <li>
                <Link to="/users">
                  <i className="bx bx-user"></i>
                  <span>{props.t("Users")}</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/settings">
                <i className="bx bx-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
